var _path, _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
    fill: "#1D4F8B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2349_15396)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.92578,
    y: 5.25,
    width: 12.15,
    height: 13.5,
    rx: 1.34993,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.90234 2.5498H19.7641V18.4115H11.8607H3.90234V2.5498ZM11.8607 7.83705C12.5774 7.83705 13.1837 7.2863 13.1837 6.51524C13.1837 5.79926 12.5774 5.19343 11.8607 5.19343C11.089 5.19343 10.5378 5.79926 10.5378 6.51524C10.5378 7.2863 11.089 7.83705 11.8607 7.83705ZM10.0968 10.4807C10.0968 10.9764 10.4827 11.3619 10.9788 11.3619V14.0055C10.4827 14.0055 10.0968 14.4461 10.0968 14.8867C10.0968 15.3824 10.4827 15.7679 10.9788 15.7679H12.7427C13.1837 15.7679 13.6247 15.3824 13.6247 14.8867C13.6247 14.4461 13.1837 14.0055 12.7427 14.0055V10.4807C12.7427 10.0401 12.3017 9.59947 11.8607 9.59947H10.9788C10.4827 9.59947 10.0968 10.0401 10.0968 10.4807Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0968 10.4807C10.0968 10.9764 10.4827 11.3619 10.9788 11.3619V14.0055C10.4827 14.0055 10.0968 14.4461 10.0968 14.8867C10.0968 15.3824 10.4827 15.7679 10.9788 15.7679H12.7427C13.1837 15.7679 13.6247 15.3824 13.6247 14.8867C13.6247 14.4461 13.1837 14.0055 12.7427 14.0055V10.4807C12.7427 10.0401 12.3017 9.59947 11.8607 9.59947H10.9788C10.4827 9.59947 10.0968 10.0401 10.0968 10.4807Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8607 7.83705C12.5774 7.83705 13.1837 7.2863 13.1837 6.51524C13.1837 5.79926 12.5774 5.19343 11.8607 5.19343C11.089 5.19343 10.5378 5.79926 10.5378 6.51524C10.5378 7.2863 11.089 7.83705 11.8607 7.83705Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.95487 7.69318C7.95487 7.2256 8.33286 6.82996 8.81884 6.82996H10.5468C11.0148 6.82996 11.4108 7.2256 11.4108 7.69318V9.41963C11.4108 9.90519 11.0148 10.2829 10.5468 10.2829H8.81884C8.33286 10.2829 7.95487 9.90519 7.95487 9.41963V7.69318ZM9.10683 7.98092V9.13189H10.2588V7.98092H9.10683ZM7.95487 12.297C7.95487 11.8295 8.33286 11.4338 8.81884 11.4338H10.5468C11.0148 11.4338 11.4108 11.8295 11.4108 12.297V14.0235C11.4108 14.5091 11.0148 14.8867 10.5468 14.8867H8.81884C8.33286 14.8867 7.95487 14.5091 7.95487 14.0235V12.297ZM9.10683 12.5848V13.7357H10.2588V12.5848H9.10683ZM13.4267 6.82996H15.1546C15.6226 6.82996 16.0186 7.2256 16.0186 7.69318V9.41963C16.0186 9.90519 15.6226 10.2829 15.1546 10.2829H13.4267C12.9407 10.2829 12.5627 9.90519 12.5627 9.41963V7.69318C12.5627 7.2256 12.9407 6.82996 13.4267 6.82996ZM14.8667 7.98092H13.7147V9.13189H14.8667V7.98092ZM12.5627 11.7216C12.5627 11.5777 12.6887 11.4338 12.8507 11.4338H14.0027C14.1467 11.4338 14.2907 11.5777 14.2907 11.7216C14.2907 11.8834 14.4167 12.0093 14.5787 12.0093H15.1546C15.2986 12.0093 15.4426 11.8834 15.4426 11.7216C15.4426 11.5777 15.5686 11.4338 15.7306 11.4338C15.8746 11.4338 16.0186 11.5777 16.0186 11.7216V13.448C16.0186 13.6099 15.8746 13.7357 15.7306 13.7357H14.5787C14.4167 13.7357 14.2907 13.6099 14.2907 13.448C14.2907 13.3041 14.1467 13.1603 14.0027 13.1603C13.8407 13.1603 13.7147 13.3041 13.7147 13.448V14.599C13.7147 14.7608 13.5707 14.8867 13.4267 14.8867H12.8507C12.6887 14.8867 12.5627 14.7608 12.5627 14.599V11.7216ZM14.5787 14.8867C14.4167 14.8867 14.2907 14.7608 14.2907 14.599C14.2907 14.4551 14.4167 14.3112 14.5787 14.3112C14.7227 14.3112 14.8667 14.4551 14.8667 14.599C14.8667 14.7608 14.7227 14.8867 14.5787 14.8867ZM15.7306 14.8867C15.5686 14.8867 15.4426 14.7608 15.4426 14.599C15.4426 14.4551 15.5686 14.3112 15.7306 14.3112C15.8746 14.3112 16.0186 14.4551 16.0186 14.599C16.0186 14.7608 15.8746 14.8867 15.7306 14.8867Z",
    fill: "#1D4F8B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.94922,
    y: 16.0498,
    width: 8.1,
    height: 1.35,
    rx: 0.675,
    fill: "#1D4F8B"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.5883,
    y: 4.91252,
    width: 12.825,
    height: 14.175,
    rx: 1.68742,
    stroke: "#1D4F8B",
    strokeWidth: 0.674967
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2349_15396"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.92578,
    y: 5.25,
    width: 12.15,
    height: 13.5,
    rx: 1.34993,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSolid);
export default __webpack_public_path__ + "static/media/info-solid.710829a859685d61faa9758dd776a042.svg";
export { ForwardRef as ReactComponent };